import { z } from "zod";

export type PackagingReferenceKind = "element" | "composite";

export const PackagingReferenceKindSchema: z.ZodType<PackagingReferenceKind> = z.union([
    z.literal("element"),
    z.literal("composite"),
]);

export type PackagingReferenceUnified = {
    "@id"?: string;
    compositeId: string;
    kind: PackagingReferenceKind;
    id: number;
    name: string;
    code?: string | null;
    defaultWeight?: number | null;
    ssqId?: number | null;
};

export const PackagingReferenceUnifiedSchema: z.ZodType<PackagingReferenceUnified> = z.object({
    "@id": z.string().optional(),
    compositeId: z.string(),
    kind: PackagingReferenceKindSchema,
    id: z.number(),
    name: z.string(),
    code: z.string().nullable().optional(),
    defaultWeight: z.number().nullable().optional(),
    ssqId: z.number().nullable().optional(),
});
